import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext.jsx';
import Layout from './components/Layout.jsx';

import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Clipboard from './pages/Clipboard.jsx';
import Snaps from './pages/Snaps.jsx';
import Search from './pages/Search.jsx';
import Devices from './pages/Devices.jsx';
import Settings from './pages/Settings.jsx';
import Admin from './pages/Admin.jsx';
import Notes from './pages/Notes.jsx';
import Shared from './pages/Shared.jsx';

import { syncEngine } from './services/sync.js';
import { useEffect } from 'react';

const Protected = ({ children, adminOnly = false }) => {
  const { isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/app/clipboard" replace />;
  return <Layout>{children}</Layout>;
};

export default function App() {
  useEffect(() => {
    syncEngine.init();
    return () => syncEngine.stop();
  }, []);

  return (
    <Routes>
      <Route path="/"          element={<Navigate to="/app/clipboard" replace />} />
      <Route path="/login"     element={<Login />} />
      <Route path="/app"       element={<Navigate to="/app/clipboard" replace />} />
      <Route path="/app/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/app/clipboard" element={<Protected><Clipboard /></Protected>} />
      <Route path="/app/snaps"     element={<Protected><Snaps /></Protected>} />
      <Route path="/app/notes"     element={<Protected><Notes /></Protected>} />
      <Route path="/app/shared"    element={<Protected><Shared /></Protected>} />
      <Route path="/app/search"    element={<Protected><Search /></Protected>} />
      <Route path="/app/devices"   element={<Protected><Devices /></Protected>} />
      <Route path="/app/settings"  element={<Protected><Settings /></Protected>} />
      <Route path="/app/admin"     element={<Protected adminOnly><Admin /></Protected>} />
      <Route path="*"         element={<Navigate to="/" replace />} />
    </Routes>
  );
}
